module.exports = {"TXTCLI_More":{"id":"TXTCLI_More","defaultMessage":"Περισσότερα","flags":["TRACK"],"track":"More"}}